/**
 * Common utility functions for booking payment calculations
 */

import { PAYMENT_OPTIONS } from "pagesV2/pro/Bookings/constants"

export const calculatePaymentBreakdown = ({
  booking = {},
  bookingSelections = {},
  depositPercent = 0,
  customDepositAmount = 0,
  paymentOption = "",
  discountAmount = 0
}) => {
  const { payment_summary = {}, payment_history = [], payment_option } = booking
  const { deposit_later, deposit_cash, deposit_link, deposit_link_in_cash } = PAYMENT_OPTIONS

  const { remaining_balance = 0 } = payment_summary
  const payment_status = booking?.payment_status

  const amount = Math.max(0, (bookingSelections?.amount || 0) - discountAmount)
  const percent = Number(customDepositAmount || depositPercent) || 0
  const isDeposit = [deposit_later, deposit_cash, deposit_link, deposit_link_in_cash].includes(payment_option || paymentOption)

  // Deposit calculations
  const paidDepositAmount =
    payment_history
      ?.filter((payment) => payment?.type?.toLowerCase() === "deposit")
      .reduce((sum, payment) => sum + (payment?.amount || 0), 0) || 0

  const depositAmount = (amount * percent) / 100
  const depositDueNow = Math.max(0, depositAmount - paidDepositAmount)

  // Balance calculations
  // Exclude tips from total paid amount as they don't reduce the booking balance
  const totalPaidAmount =
    payment_history?.reduce((sum, payment) => {
      if (payment?.type?.toLowerCase() === "tip") return sum
      return sum + (payment?.amount || 0)
    }, 0) || 0
  const refundDueNow = totalPaidAmount > amount ? Math.abs(totalPaidAmount - amount) : 0
  const balanceAmount = isDeposit ? amount - totalPaidAmount - depositDueNow : amount - totalPaidAmount

  return {
    // Core values
    amount,
    percent,
    remaining_balance,

    // Deposit related
    depositAmount,
    depositDueNow,
    paidDepositAmount,

    // Payment related
    balanceAmount,

    // Status flags
    payment_status,
    isDeposit,

    // Raw data
    payment_history,
    payment_summary,
    refundDueNow
  }
}
